import { render, staticRenderFns } from "./CompanyNews.vue?vue&type=template&id=fbede722&scoped=true&"
import script from "./CompanyNews.vue?vue&type=script&lang=js&"
export * from "./CompanyNews.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNews.vue?vue&type=style&index=0&id=fbede722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbede722",
  null
  
)

export default component.exports